import { twMerge } from "tailwind-merge";
import { composeRenderProps } from "react-aria-components";
function composeTailwindRenderProps(n, r) {
	return composeRenderProps(n, (t) => twMerge(r, t));
}
function cx(...n) {
	let r = n;
	n.length === 1 && Array.isArray(n[0]) && (r = n[0]);
	let i = r.pop(), a = twMerge(...r);
	return composeRenderProps(i, (t) => twMerge(a, t));
}
export { cx as n, composeTailwindRenderProps as t };
